import debug from 'debug';
import keyBy from 'lodash.keyby';

import * as teamTypes from '../actions/teams.types';

// const log = debug('huddle:store:reducers:teams');

const teamsLoading = state => ({
  ...state,
  loading: true,
});

const teamsError = (state, { payload: { error } }) => ({
  ...state,
  loading: false,
  error,
});

const teamsData = (state, { teams }) => ({
  loading: false,
  error: null,
  ...keyBy(teams, 'id'),
});

const teamsView = (state, { id }) => ({
  ...state,
  selectedId: id,
});

const teamsReducer = (state = teamTypes.INITIAL_TEAMS, action = {}) => {
  const { type, payload, error } = action;
  switch (type) {
    case teamTypes.TEAMS_FETCH:
      return teamsLoading(state);
    case teamTypes.TEAMS_RECEIVED:
      return teamsData(state, payload);
    case teamTypes.TEAMS_ERROR:
      return teamsError(state, error);
    case teamTypes.VIEW_TEAMS:
      return teamsView(state, payload);
    default:
      return state;
  }
};

export default teamsReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/teams.js